import styled from 'styled-components';
import { typography, color, ColorProps, TypographyProps } from 'styled-system';

import { Colors } from 'theme/colors';
import { Container } from 'theme/layout';
import { FontSize, FontWeight } from 'theme/fonts';

export {
  Button,
  CloseButton,
  Footer,
  ModalInner,
  Title,
  ButtonDivider,
  HeaderContainer,
  Circle,
  IconContainer,
  BackButton,
} from './styles.native';

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Overlay = styled.div`
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled(Container)`
  background-color: ${Colors.siam};
  border-radius: 15px;
  overflow: hidden;
  max-width: 400px;
  align-self: center;
  width: 95%;
`;

export const Description = styled.span<ColorProps & TypographyProps>`
  text-align: center;
  color: ${Colors.black};
  font-size: ${FontSize.H6};
  font-family: 'Roboto';
  font-weight: ${FontWeight.Light};
  margin-right: 30px;
  margin-left: 30px;
  margin-top: 5px;
  line-height: 21px;
  ${typography};
  ${color};
`;

export const RoseModalImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 30px;
`;

export const ProspectExpiredContent = styled(Container)`
  align-self: center;
  max-width: 80%;
  justify-content: center;
`;

export const ProspectExpiredHeading = styled.p`
  font-weight: ${FontWeight.Bold};
  color: ${Colors.black};
  line-height: 28px;
  font-size: 20px;
  text-align: center;
  letter-spacing: 0px;
  margin: 0;
`;

export const ProspectExpiredDescription = styled.p`
  margin-top: 24px;
  margin-bottom: 0px;
  font-weight: ${FontWeight.Light};
  color: ${Colors.boulder};
  line-height: 26px;
  font-size: 16px;
  letter-spacing: 0px;
  text-align: center;
`;
